//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  maxLength,
  required,
} from 'vuelidate/lib/validators';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import AiToolsMixin from '@/components/mixins/ai-tools.mixin.js';
import PredictionMixin from '@/components/mixins/prediction.mixin.js';

export default {
  name: 'ImageVariations',
  mixins: [AiToolsMixin, PredictionMixin, featureFlagMixin],
  components: {
    ToolImageLayout: () => import('@/components/core/ToolImageLayout.vue'),
    SourceImage: () => import('@/components/tools/SourceImage.vue'),
    DemoSourceImages: () => import('@/components/tools/DemoSourceImages.vue'),
    SelectButtons: () => import('@/components/tools/SelectButtons.vue'),
    PromptTextarea: () => import('@/components/tools/PromptTextarea.vue'),
  },
  data() {
    return {
      form: {
        model: 'image_variation',
        image: null,
        demoImage: null,
        variationStrength: 100,
        prompt: '',
        numOutputs: 4,
      },
      prediction: {
        image: null,
      },
      variationStrengthValues: [
        {
          value: 50,
          title: '50%',
        },
        {
          value: 80,
          title: '80%',
        },
        {
          value: 100,
          title: '100%',
        },
      ],
      demoImages: [
        {
          labelImage: 'https://static.moele.me/img/studio-ai/image_variations/thumbnails/thumbnail1.jpg?auto=format&w=88',
          value: 'ImageVariation_sample1',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/image_variations/thumbnails/thumbnail2.jpg?auto=format&w=88',
          value: 'ImageVariation_sample2',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/image_variations/thumbnails/thumbnail3.jpg?auto=format&w=88',
          value: 'ImageVariation_sample3',
        },
      ],
    };
  },
  validations: {
    form: {
      image: {
        required: required,
      },
      prompt: {
        required: required,
        maxLength: maxLength(1000),
      },
    },
  },
  computed: {
    tool() {
      return this.aiToolsTranslations[this.aiToolsIds.IMAGE_VARIATIONS];
    },
    demoOutput() {
      if (this.form.demoImage) {
        const imagePath = `https://static.moele.me/img/studio-ai/${this.aiToolsIds.IMAGE_VARIATIONS}/output/${this.form.demoImage}`;
        return Array(4).fill(imagePath).map((item, index) => {
          if (index === 0) {
            return `${item}.jpg?auto=format&w=524`;
          }
          return `${item}-${index}.jpg?auto=format&w=524`;
        });
      }
      return null;
    },
  },
  methods: {
    clearForm() {
      this.form.model = null;
      this.form.image = null;
      this.form.demoImage = null;
      this.form.prompt = '';
    },
  },
};
